import styled from 'styled-components';

export const StickyBanner = styled.div`
  padding-top: 0;
  width: var(--full-width);
  margin-top: 62px;
  margin-left: -${({ offset }) => offset}px;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  background-color: ${(props) => props.theme.colors.white};
  z-index: 11;
  flex-direction: column;

  .reject-msg-box {
    position: relative;
    width: 100%;
    padding: 24px 0;
    background: ${(props) => props.theme.colors.bgBox};
    box-shadow: 4px 6px 60px 0px rgba(4, 86, 179, 0.1);
    z-index: 10;

    .h3 svg {
      margin-left: 6px;
      stroke: ${(props) => props.theme.colors.textPrimary};
    }
  }

  .btns-banner {
    min-height: 88px;
    display: flex;
    align-items: center;
    width: 100%;
    box-shadow: 4px 6px 60px 0px rgba(4, 86, 179, 0.1);

    @media ${(props) => props.theme.device.mobileL} {
      > div {
        flex-direction: column-reverse;
      }
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    margin-left: -22px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    margin-top: 0;
    margin-left: -16px;
  }

  .legend-mandatory {
    margin-left: 40px;
    color: ${(props) => props.theme.colors.fail};
  }

  .warning {
    margin: 0 40px 0 auto;
    color: #646464;
    max-width: 560px;
    gap: 16px;

    svg {
      stroke: #646464;
    }
  }

  > div {
    @media ${(props) => props.theme.device.mobileL} {
      flex-direction: column-reverse;
      padding-bottom: 24px;
      padding-top: 24px !important;
    }
  }

  .btns-wrapper {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 24px;

    @media ${(props) => props.theme.device.mobileL} {
      flex-direction: column-reverse;
      margin-left: unset;
      width: 100%;
      gap: 8px;
    }
  }
`;

export const MsgInfoBox = styled.div`
  width: 370px;
  border-radius: 24px;
  background: ${(props) => props.theme.colors.white};
  padding: 24px;
  position: absolute;
  bottom: 200px;
  left: 48px;
  box-shadow: 4px 60px 60px 9999999px rgba(0, 0, 0, 0.4);

  button {
    margin: auto;
  }

  @media ${(props) => props.theme.device.mobileL} {
    max-width: 100vw;
    bottom: 250px;
    left: 12px;
  }
`;
